import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IGoogleAdsCampaignDetail } from "../../features/Campaigns/interface";
import { useAuth } from "../helper/useAuth";

interface UseCampaignDetailParams {
  campaignId: string | number;
  startDate?: Date;
  endDate?: Date;
}

export const useCampaignDetail = ({
  campaignId,
  startDate,
  endDate,
}: UseCampaignDetailParams) => {
  const { selectedIntegration } = useAuth();

  return useQuery<IGoogleAdsCampaignDetail>({
    queryKey: [
      "google-ads-campaign-detail",
      String(campaignId),
      startDate?.toISOString(),
      endDate?.toISOString(),
      selectedIntegration?.value,
    ],
    queryFn: async () => {
      const url = API_CONFIG.path.googleAdsCampaignDetail.replace(
        ":id",
        String(campaignId),
      );
      const queryParams: Record<string, string> = {
        tracking_id: selectedIntegration?.value as string,
      };

      if (startDate) {
        queryParams.start_date = startDate.toISOString().split("T")[0];
      }
      if (endDate) {
        queryParams.end_date = endDate.toISOString().split("T")[0];
      }

      return httpService.get<IGoogleAdsCampaignDetail>(url, queryParams);
    },
    enabled: !!campaignId && !!selectedIntegration?.value,
  });
};
